// import { useAuth } from 'context/AuthContext';

const UnverifiedUserMessage = () => {
  // const { user, loading } = useAuth();
  // const { user } = useAuth();

  // temporarily
  // if (user) {
  //     return (
  //         <div className="alert alert-warning w-75 m-auto mb-2 fs-seven" role="alert">
  //             This is a demo environment. All funds are simulated and not real. As such, real withdrawals are disabled.
  //         </div>
  //     );
  // } else
  return null;

  // if (loading) return null;
  // if (!user || user.is_email_verified) return null;

  // return (
  //     <div className="alert alert-warning" role="alert">
  //         Orders and withdrawals are disabled for unverified users.
  //     </div>
  // );
};

export default UnverifiedUserMessage;
